export const CONFIG = {
  PAYMENT_SERVICE_ID: process.env.REACT_APP_PAYMENT_SERVICE_ID,
  SOURCE_PLATFORM: process.env.REACT_APP_SOURCE_PLATFORM
};
